module.exports = __webpack_public_path__ + "static/7-d53ac39c405266f785a3d184eee46c12.png";